import {
  AfterContentInit,
  ChangeDetectionStrategy, ChangeDetectorRef,
  Component,
  ContentChild,
  EventEmitter, Inject,
  Input, OnInit, Optional,
  Output,
  TemplateRef
} from "@angular/core";
import {BehaviorSubject} from "rxjs";
import {FormBuilder, FormGroup} from "@angular/forms";
import {IntTableColumnsLimiterService} from "./int-table-columns-limiter.service";
import {DestroyStreamService} from "../../services";
import {INT_PORTAL_SLOT_UPDATE_POSITION_INTERVAL} from "../../modules";
import {takeUntil} from "rxjs/operators";
import {IntTableColumnsLimiterItemDirective} from "./int-table-columns-limiter-item.directive";

@Component({
  selector: 'int-table-columns-limiter',
  templateUrl: './int-table-columns-limiter.component.html',
  styleUrls: ['./int-table-columns-limiter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    DestroyStreamService,
    {
      provide: INT_PORTAL_SLOT_UPDATE_POSITION_INTERVAL,
      useValue: 500
    }
  ]
})
export class IntTableColumnsLimiterComponent<T extends object>
  implements AfterContentInit, OnInit
{
  @Input() hideOnLoadList: Array<string> | null = null;

  @Output() onSelect = new EventEmitter<Array<T>>();

  @ContentChild(IntTableColumnsLimiterItemDirective) readonly itemTemplate!: IntTableColumnsLimiterItemDirective;

  template$: BehaviorSubject<TemplateRef<any> | null> = new BehaviorSubject<TemplateRef<any> | null>(null);

  constructor(
    @Optional()
    @Inject(IntTableColumnsLimiterService)
    readonly columnsService: IntTableColumnsLimiterService<T>,
    private readonly cdr: ChangeDetectorRef
  ) {
    if(!this.columnsService) {
      console.warn(`Please provide [IntTableColumnsLimiterService] in IntTableColumnsLimiterComponent`)
    }
  }

  get init() {
    return this.columnsService?.formHasBeenInit$?.value
  }

  isExistInFormattedList(record: T) {
    const value = this.columnsService.getValue(record);
    return this.columnsService.formattedList
      .map(item => this.columnsService.getValue(item))
      .some(item => item === value)
  }

  ngOnInit() {}

  showAll() {
    this.columnsService.showAll();
  }

  ngAfterContentInit() {
    if(this.itemTemplate) {
      this.template$.next(this.itemTemplate.templateRef);
    }
  }
}
